module.exports = __webpack_public_path__ + "static/317939799_666027215193717_513834572527467737_n.jpg-1671186393237_512-7013454db3f3151107cae0f64392a97e.webp";